const OSS = require('ali-oss')
const parallelList = [
  {
    label: 1,
    value: 4
  },
  {
    label: 5,
    value: 3
  },
  {
    label: 10,
    value: 2
  },
  {
    label: 15,
    value: 1
  }
]
const partSizeList = [
  {
    label: 1 * 1024 * 1024,
    value: 1 * 1024 * 1024
  },
  {
    label: 300 * 1024 * 1024,
    value: 900 * 1024
  },
  {
    label: 600 * 1024 * 1024,
    value: 800 * 1024
  },
  {
    label: 900 * 1024 * 1024,
    value: 600 * 1024
  },
  {
    label: 910 * 1024 * 1024,
    value: 500 * 1024
  }
]
import { mapActions } from 'vuex'
import axios from 'axios'
export const uploadQiNiuyun = {
	methods: {
		...mapActions('uploads', ['materialAdd']),
		randomString(e) {
			e = e || 32;
			var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
				a = t.length,
				n = "";
			for (var i = 0; i < e; i++) {
				n += t.charAt(Math.floor(Math.random() * a))
			}
			return n + Date.now()
		},
		async uploadSdk(file, params, index) {
      let parallel,
      partSize;
      for (const item of parallelList.reverse()) {
        if(this.uploadList.length >= item.label) {
          parallel = item.value
          break;
        }
      }
      for (const item of partSizeList.reverse()) {
        if(file.size >= item.label) {
          partSize = item.value
          break;
        }
      }
      const client = new OSS({
      // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
      region: this.requestUploadParams.region,
      // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
      accessKeyId: params.AccessKeyId,
      accessKeySecret: params.AccessKeySecret,
      // 从STS服务获取的安全令牌（SecurityToken）。
      stsToken: params.SecurityToken,
      // 填写Bucket名称。
      bucket: this.requestUploadParams.bucket,
      refreshSTSToken: async () => {
        let res =  await this.httprequest({
          method: 'get',
          url: '/v1/ali/token',
          data: {}
        })
        return {
          accessKeyId: res.AccessKeyId,
          accessKeySecret: res.AccessKeySecret,
          stsToken: res.SecurityToken
        }
      },
      refreshSTSTokenInterval: 20 * 60 * 1000
    })
    this.observable = client
    const options = {
      // 获取分片上传进度、断点和返回值。
      progress: (p, cpt, res) => {
        if(!this.uploadList[index].uploadId) {
          this.$set(this.uploadList[index], 'uploadId', cpt.uploadId)
          this.$set(this.uploadList[index], 'uploadPath', cpt.name)
        }
        this.$set(this.uploadList[index], 'type', 'pend')
        let process = parseInt(p * 100)
        if(process<=99) {
          this.$set(this.uploadList[index], 'process', process)
        }
      },
      // 设置并发上传的分片数量。
      parallel: parallel,
      // 设置分片大小。默认值为1 MB，最小值为100 KB。
      partSize: partSize,
      timeout: 30 * 60 * 1000,
      // mime: "text/plain",
    }
    try {
      let res = ''
      const uploadPath =  this.requestUploadParams.projectFirst + this.requestUploadParams.projectSecond + params.date_dir + '/'+ this.randomString(20) + this.uploadList[index].suffix
      if(file.size < 110 * 1024) {
        const getProcess = (process=0) => {
          if(!this.uploadList[index].uploadId) {
            this.$set(this.uploadList[index], 'uploadId', this.uploadList[index].newFileName)
            this.$set(this.uploadList[index], 'uploadPath', uploadPath)
          }
          this.$set(this.uploadList[index], 'type', 'pend')
          if(process <= 98) {
            process++
            this.$set(this.uploadList[index], 'process', process)
            getProcess(process)
          }
        }
        getProcess()
        res = await client.put(
          uploadPath,
          file
        )
        console.log(res, '======')
      } else {
        res = await client.multipartUpload(
          uploadPath,
          file,
          {
            ...options
          }
        )
      }
      let filesObj = this.uploadList[index]
      const url = this.requestUploadParams.zip?  this.requestUploadParams.domain  + '/' + res.name + this.requestUploadParams.zip + filesObj.suffix.toLocaleLowerCase().replace(/./, '') : this.requestUploadParams.domain  + '/' + res.name
      if(!this.isAddSucaiFlag) {
        let obj = {
          process: 100,
          url: url,
          type: 'success'
        }
        this.$set(this.uploadList[index], 'url', url)
        this.$set(this.uploadList[index], 'type', 'success')
        this.$set(this.uploadList[index], 'process', 100)
        this.$set(this.uploadList, index, {...this.uploadList[index], ...obj})
        this.$emit('uploadSucess', this.uploadList,this.uploadList[index] )
        return
      }
      let result = await this.materialAdd(
        {
          type: filesObj.fileType,
          material_size: filesObj.size,
          origin_name: filesObj.name,
          material_url: url,
        })
        let obj = {
          id: result.id.id,
          vertically: result.id.vertically,
          duration: result.id.material_time,
          process: 100,
          url: url,
          type: 'success'
        }
        this.$set(this.uploadList, index, {...this.uploadList[index], ...obj})
        this.$emit('uploadSucess', this.uploadList,this.uploadList[index])
      } catch (err) {
        this.$set(this.uploadList[index], 'type', 'error')
        this.$message({
          showClose: true,
          message: '上传失败，请重新上传',
          type: 'error'
        })
		const userClientInfo = {
			fileSize: (file.size /1024/1024).toFixed(2) + 'M',
			userAgent: client.userAgent,
			name: file.name,
			type: file.type
		}
		this.reportToFeishuRobot({'err':err,'fileInfo': userClientInfo})
      }
		},
		reportToFeishuRobot (contents) {
			const times = new Date()
			let userInfo = {
				id: '默认',
				name: '默认',
			}
			try{
				userInfo = {
					id: localStorage.getItem('id'),
					name: localStorage.getItem('name'),
				}
			}catch(e){
				//TODO handle the exception
			}

			const config = {
				title: '讲师PC端上传-消息通知',
				url:'https://open.feishu.cn/open-apis/bot/v2/hook/83a7199c-7044-4a42-bf2a-9bade7e50862',
				userInfo: {
					id: userInfo.id,
					nickname:  userInfo.name
				},
				timestamp: times.toLocaleDateString() + ' ' + times.toLocaleTimeString(),
				data: contents,
				env: process.env.VUE_APP_GRALIC
			}
			
			const data = {
					"msg_type": "post",
					"content": {
						"post": {
							"zh_cn": {
								"title": config.title,
								"content": [
									[{
										"tag": "text",
										"text": `用户ID:${config.userInfo.id}\n用户昵称:${config.userInfo.nickname}`
									}
									],
									[{
										"tag": "text",
										"text": `文件内容:${JSON.stringify(config.data.fileInfo)}`,
									}],
									[{
										"tag": "text",
										"text": `错误内容:${JSON.stringify(config.data.err)}`,
									}],
									[{
											"tag": "text",
											"text": `报告时间:${config.timestamp} 环境:${config.env}`,
										}
									]
								]
							}
						}
					}
				}
			axios.post(config.url,data)
			  .then(function (response) {
			  })
			  .catch(function (error) {
			  })
		}
		
	}
}
